<template>
    <div class="modal" @click="outsideClick()">
        <div class="plan-modal modal-box">
            <div class="close" @click="$emit('close')">
                <span>X</span>
            </div>
            <div class="modal-body">
                <span class="title">{{title}}</span>
                <img v-if="img == 'at'" src="@/assets/images/kit-plans/piramide-atividades.png" />
                <img v-if="img == 'al'" src="@/assets/images/kit-plans/piramide-alimentar.png" />
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "modal",
        props: ['title', 'img'],
        components: { },
        data() {
            return {
                plural: false,
                metricList: [],
            }
        },
        methods: {
            outsideClick() {
                if(event.target === event.currentTarget)
                    this.$emit('close');
            },
        }
    }
</script>

<style scoped>
    .modal-box {
        max-width: 650px;
    }
    .modal-body {
        max-height: 500px;
        overflow-y: auto;
    }
    @media screen and (max-width: 850px) {
        .modal-box {
            width: 100%;
            margin-right: 20px;
            margin-left: 20px;
        }
    }
    @media screen and (max-height: 650px) {
        .modal-box {
            min-height: 80vh;
            max-height: 80vh;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/KitPlans/Modal.vue